<template>
  <v-container fluid>
    <subHeader />

    <v-row class="d-flex justify-center align-center">
			<v-container style="width: 80%;">
				<v-row>
					<v-col>
						<h2 class="duo" style="font-family: AirNZ Sans Regular !important; font-size: 28px !important; color: black !important">
							<span style="font-family: AirNZ Sans Semibold !important">duo</span>&nbsp;passport
						</h2>
					</v-col>
					<v-col >
						<div class="d-flex justify-end">
							<div style="width: 25vw;">
								<v-img :src="$bucket + '/image/training-tiles/Logo.png'" position="right top"></v-img>
							</div>
						</div>
					</v-col>
				</v-row>

				<p class="duo" style="font-size: 17px; margin-bottom: 30px; color: black !important">
					Get ready to explore the USA—one booking at a time! For every U.S. city flight you sell, you’ll collect a passport stamp and move one step closer to exclusive rewards. Whether it’s New York, Los Angeles, Chicago, or beyond, each sale is a stamp on your agent passport. The more cities you “visit,” the more entries you get.
				</p>
        
        <h2 class="duo" style="font-family: AirNZ Sans Regular !important; font-size: 28px !important; color: black !important">
					<span style="font-family: AirNZ Sans Semibold !important">Start booking, start stamping, and start winning!</span>
				</h2>

        <div v-if="flipbookLoaded && startPage > 0" style="margin-top: 1vw; margin-bottom: 1vw;">
			<!-- <pre>Stamp Size : {{ stampSize }}</pre>
			<pre>Passport Page : {{ passportPages.length }}</pre>
			<pre>Math ceil : {{ Math.ceil(stampSize / 12) }}</pre>
			<pre>Start Page : {{ Math.ceil(stampSize / 12) % 2 == 0 ? Math.ceil(stampSize / 12) + 1 : Math.ceil(stampSize /6 -1)}}</pre> -->
			<flipbook class="flipbook" :pages="passportPages" :clickToZoom="false" :startPage="startPage"></flipbook>
        </div>
        <div v-else>Loading Passport...</div>

        <v-row no-gutters class="custom-v-card mb-2 elevation-0" align="center" justify="center" style="border-radius: 6px">
          <v-col class="d-flex flex-column">
            <v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 15px 24px">
              <v-col class="px-1 pt-8" cols="auto" xl="2" lg="2" md="2" sm="4" xs="12" style="font-family: AirNZ Sans Semibold; font-size: 22px; line-height: 21px; color: black !important">
                <strong>Add Booking</strong>
              </v-col>
            </v-row>

            <v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 0px 24px">
              <v-col class="px-1">
                Booking reference number
              </v-col>
            </v-row>

			<!-- start NZ -->
			<v-row>
				<v-col>
					<v-form ref="form" class="mb-8" v-model="valid" autocomplete="off" lazy-validation :style="{ margin: '0 auto', display: 'block', width: '100%' }">
						<v-row no-gutters class="row-pnr-input d-flex justify-space-between pr-1">
							<!-- pnr boxes -->
							<v-col class="d-none d-sm-block">
								<v-pnr-input
									:disabled="booking.creationDateUA != null || booking.ticketNumber != null"
									class="mb-2"
									ref="pnrCodeInput"
									:input-classes="String('pnr-input' + ' ' + 0)"
									separator=" "
									:bookingCode="bookingCode"
									:num-inputs="5"
									:should-auto-focus="true"
									@on-change="handleOnChange"
									@on-complete="handleOnComplete"
								/>
								<span id="errorPNR" class="error--text pl-1 mt-n6 duo"></span>
							</v-col>
							<!-- pnr boxes end -->

							<!-- pnr form -->
							<v-col class="d-block d-sm-none px-5" cols="12">
								<v-text-field
									:disabled="booking.creationDateUA != null  || booking.ticketNumber != null"
									id="pnrCode"
									v-model="booking.bookingCode"
									suffix="H"
									maxlength="5"
									class="pt-0"
									label="PNR"
									@input="handleOnInput($event, booking)"
									:rules="[
										(value) => {
											const pattern = /[a-zA-Z0-9]$/g;
											return pattern.test(value) || 'Invalid PNR.';
										},
									]"
									@paste="handleOnPaste($event, booking)"
									style="margin-top: 30px; font-size: 17px !important; font-family: AirNZ Sans Regular !important"
								></v-text-field>
							</v-col>
							<!-- pnr form end -->

							<!-- datepicker -->
							<v-col class="px-5" style="min-width: 200px">
								<v-row no-gutters>
									<v-menu :disabled="booking.creationDateUA != null || booking.ticketNumber != null" ref="datePickerCreation" v-model="booking.menu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="320px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												:disabled="booking.creationDateUA != null || booking.ticketNumber != null"
												id="pnrCreationDate"
												:value="parseDate(booking.creationDate)"
												readonly
												v-on="on"
												v-bind="attrs"
												:rules="[
														v => v === null || v === undefined || v.length < 1 ? true : !!v || 'Enter a PNR Creation Date'
													]"
												@click:prepend="booking.menu = true"
											>
												<template v-slot:append>
													<img v-on="on" v-bind="attrs" width="24" height="24" src="/icon/icon-calendar.svg" />
												</template>
												<template v-slot:label>
													<span style="font-size: 17px; color: black !important">PNR creation date</span>
												</template>
											</v-text-field>
										</template>
										<v-date-picker v-model="booking.creationDate" :allowed-dates="allowedDates" :max="currentDate" no-title scrollable style="width: 100%">
											<v-row no-gutters justify="space-around" class="pa-4">
												<v-btn width="120" class="mx-0" outlined color="primary" @click="$refs.datePickerCreation.save(booking.creationDate); booking.menu = false;">Confirm</v-btn>
												<v-btn width="120" class="mx-0" outlined @click="booking.menu = false">Cancel</v-btn>
											</v-row>
										</v-date-picker>
									</v-menu>
								</v-row>
								<v-row no-gutters class="d-flex flex-row" justify="end" style="margin-top: -1vw;">
									<v-btn class="ma-0 pa-0 mr-n2" text @click="resetFormPnr"> Clear all </v-btn>
								</v-row>
							</v-col>
							<!-- datepicker end -->
						</v-row>
					</v-form>
				</v-col>
			</v-row>
			<!-- finish NZ -->

            <v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 0px 24px">
              <v-col class="px-1">
                Or Ticket Number
              </v-col>
            </v-row>

			<!-- start UA -->
			<v-row>
				<v-col>
					<v-form ref="form" class="mb-2" v-model="valid" autocomplete="off" lazy-validation :style="{ margin: '0 auto', display: 'block', width: '100%' }">
						<v-row no-gutters class="row-pnr-input d-flex justify-space-between pr-1">
							<!-- pnr boxes -->
							<v-col class="d-none d-sm-block">
								<v-ua-input
									:disabled="booking.creationDate != null || booking.bookingCode != null"
									class="my-2"
									ref="uaCodeInput"
									:input-classes="String('pnr-input' + ' ' + 1)"
									separator=" "
									:bookingCode="booking.ticketNumber"
									:num-inputs="10"
									:should-auto-focus="true"
									@on-change="handleOnChangeUA"
									@on-complete="handleOnCompleteUA"
								/>
								<span id="errorUA" class="error--text pl-1 mt-n6 duo"></span>
							</v-col>
							<!-- pnr boxes end -->

							<!-- pnr form -->
							<v-col class="d-block d-sm-none px-5" cols="12">
								<!-- v-model="booking.bookingCode" -->
								<!-- @input="handleOnInput($event, booking)" -->
								<!-- @paste="handleOnPaste($event, booking)" -->
								<!-- suffix="H" -->
								<v-text-field
									:disabled="booking.creationDate != null || booking.bookingCode != null"
									id="uaCode"
									v-model="booking.ticketNumber"
									prefix="016"
									maxlength="10"
									class="pt-0"
									label="PNR"
									@input="handleOnInputUA($event, booking)"
									:rules="[
										(value) => {
											const pattern = /[a-zA-Z0-9]$/g;
											return pattern.test(value) || 'Invalid PNR.';
										},
									]"
									@paste="handleOnPasteUA($event, booking)"
									style="margin-top: 30px; font-size: 17px !important; font-family: AirNZ Sans Regular !important"
								></v-text-field>
							</v-col>
							<!-- pnr form end -->

							<!-- datepicker -->
								<v-col class="px-5" style="min-width: 200px">
									<v-row no-gutters>
										<v-menu :disabled="booking.creationDate != null || booking.bookingCode != null" ref="datePickerCreation2" v-model="booking.menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="320px">
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													:disabled="booking.creationDate != null || booking.bookingCode != null"
													id="uaCreationDate"
													:v-model="booking.creationDateUA"
													:value="parseDate(booking.creationDateUA)"
													readonly
													v-on="on"
													v-bind="attrs"
													:rules="[
														v => v === null || v === undefined || v.length < 1 ? true : !!v || 'Enter a PNR Creation Date'
													]"
													@click:prepend="booking.menu2 = true"
												>
													<template v-slot:append>
														<img v-on="on" v-bind="attrs" width="24" height="24" src="/icon/icon-calendar.svg" />
													</template>
													<template v-slot:label>
														<span style="font-size: 17px; color: black !important">PNR creation date</span>
													</template>
												</v-text-field>
											</template>
											<v-date-picker v-model="booking.creationDateUA" :allowed-dates="allowedDates" :max="currentDate" no-title scrollable style="width: 100%">
												<v-row no-gutters justify="space-around" class="pa-4">
													<v-btn width="120" class="mx-0" outlined color="primary" @click="$refs.datePickerCreation2.save(booking.creationDateUA); booking.menu2 = false;">Confirm</v-btn>
													<v-btn width="120" class="mx-0" outlined @click="booking.menu2 = false">Cancel</v-btn>
												</v-row>
											</v-date-picker>
										</v-menu>
									</v-row>
									<v-row no-gutters class="d-flex flex-row" justify="end" style="margin-top: -1vw;">
										<v-btn class="ma-0 pa-0 mr-n2" text @click="resetFormPnr"> Clear all </v-btn>
									</v-row>
								</v-col>
								<!-- datepicker end -->
						</v-row>
					</v-form>
				</v-col>
			</v-row>
			<!-- finish UA -->

          </v-col>
        </v-row>

        <v-row justify="end">
			<v-btn outlined elevation="0" id="submitPnr" class="btn-add" @click="submitAddBooking()">Add</v-btn>
		</v-row>

		<v-row class="d-flex justify-center align-center">
			<myReward @on-change="loadPassportPages" @on-load-grid="getStampSize"></myReward>
		</v-row>

      </v-container>
    </v-row>

  </v-container>
</template>

<style scoped>
h2 {
  font-family: "AirNZ Sans Semibold";
  font-size: 28px;
}

p {
  margin-top: 18px;
  font-family: "AirNZ Sans Regular";
  font-size: 17px;
}

li {
  font-family: "AirNZ Sans Regular";
  font-size: 17px;
}

a,
li a {
  margin-top: 15px;
  font-family: "AirNZ Sans Regular";
  font-size: 17px;
  text-decoration: underline;
  color: #440099;
}

a:hover {
  color: #9b4ff7 !important;
}

.flipbook {
  width: 800px;
  height: 600px;
  margin: 0 auto;
}

.custom-v-card {
	box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
	border-radius: 4px;
	background-color: rgba(255, 255, 255, 0.9);
	color: rgba(0, 0, 0, 0.87);
	border-width: thin;
	max-width: 100%;
	outline: none;
	text-decoration: none;
	transition-property: box-shadow, opacity;
	overflow-wrap: break-word;
	position: relative;
	white-space: normal;
	min-height: 166px;
	opacity: 0.9;
}
.btn-add {
	width: 162px !important;
	height: 46px !important;
	border: 1px solid #00b0b9;
	background-color: #00b0b9 !important;
	border-radius: 4px;
	opacity: 1;
	color: white !important;
	text-transform: none !important;
	font-size: 17px !important;
	letter-spacing: 0px;
  margin-bottom: 50px;
}
.row-pnr-input {
	padding: 0 15px 0 25px;
}
.pnr-input {
	width: 50px;
	height: 45px;
	/* padding: 5px; */
	margin: 0 3px;
	font-size: 20px;
	border-radius: 4px;
	border: 1px solid rgb(0, 0, 0);
	text-align: center;
}

@media (max-width: 600px) {
	.row-pnr-input {
		padding: 0 10px 10px 10px;
	}
}

</style>

<script>
/* eslint-disable no-console */
import axios from "axios";
import subHeader from "./subHeader.vue";
import pnrInput from "./pnrInput.vue";
import uaInput from "./uaInput.vue";
import myReward from "./myReward.vue";

import { unzipSync } from 'fflate';

export default {
  components: {
    subHeader,
	myReward,
    "v-pnr-input": pnrInput,
	"v-ua-input": uaInput,
  },
  props: {
    show: {
		type: Boolean,
		default: false,
		valid: true,
    },
  },
  data() {
    return {
		bookingCode: "",
		booking: {
			bookingCode : null,
			ticketNumber : null,
			
			//
			creationDate : null,
			creationDateUA : null
		},
		flipbookLoaded: false,
		passportPages: [],
		startPage: 0,
		valid: true,
		currentDate: new Date(new Date().getTime() + 1 * 24 * 60 * 60 * 1000).toJSON().slice(0, 10).replace(/-/g, "-"),
		allowedDates: (val) => val >= new Date(new Date().getTime() + -90 * 24 * 60 * 60 * 1000).toJSON().slice(0, 10).replace(/-/g, "-"),
		month_names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],

		stampSize: 0,
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
    this.loadPassportPages();
  },
  methods: {
	getStampSize(value) {
		this.stampSize = value;
		this.startPage = Math.ceil(this.stampSize / 12) % 2 == 0 ? Math.ceil(this.stampSize / 12) + 1 : (Math.ceil(this.stampSize /6 )-1)
		this.startPage = this.startPage == 0 ? 1 : this.startPage 
	},
	resetFormPnr() {

		document.getElementById("errorUA").textContent = "";
		document.getElementById("errorPNR").textContent = "";

		this.handleClearInput("pnrCodeInput");
		this.handleClearInput("uaCodeInput");
		this.$refs.form.reset();
		
		this.booking.bookingCode = null
		this.booking.ticketNumber = null
		this.booking.creationDate = null
		this.booking.creationDateUA = null

	},
	handleClearInput(ref) {
		this.$refs[ref].$el.value=null;
		this.$refs[ref]['_data']['pnr']=['','','',''];
	},
	handleOnPaste(event, booking) {
		const pastedData = event.clipboardData.getData("text/plain").toUpperCase().toString();
		booking.bookingCode = String(booking.bookingCode + pastedData).substring(0, 5);
	},
	handleOnPasteUA(event, booking) {
		const pastedData = event.clipboardData.getData("text/plain").toUpperCase().toString();
		booking.ticketNumber = String(booking.ticketNumber + pastedData).substring(0, 10);
	},
	handleOnInput(event, booking) {
		booking.bookingCode = String(event).toUpperCase();
	},
	handleOnInputUA(event, booking) {
		booking.ticketNumber = String(event).toUpperCase();
	},
	checkPnrCodeValue() {
		if ((this.booking.bookingCode == null || this.booking.bookingCode.length < 5) && (this.booking.ticketNumber == null || this.booking.ticketNumber.length < 10 )) {
			throw "Field PNR is required";
		} else {
			if (this.booking.bookingCode != null) {
				this.booking.bookingCode = this.booking.bookingCode.substring(0, 5) + "H";
			} else {
				this.booking.ticketNumber = "016" + this.booking.ticketNumber.substring(0, 10);
				this.booking.creationDate = this.booking.creationDateUA;
			}
		}
	},
	checkPnrCreationDate() {
		if (this.booking.bookingCode != null && this.booking.creationDate == null) {
			throw "Field NZ creation date is required " 
		}
		if (this.booking.ticketNumber != null && this.booking.creationDateUA == null) {
			throw "Field UA creation date is required " 
		}
	},
	submitAddBooking() {
	try {
		this.checkPnrCodeValue();
		this.checkPnrCreationDate();

		axios
			.post("/system/passport/add", {
				entity: this.booking,
			})
			.then(() => {
				this.$store.commit("showNotification", { title: "Awesome", content: "PNR has been added to your <b>sales</b> table.", color: "#00B0B9" });
				this.resetFormPnr()
				this.$root.$emit("update");
				this.loadPassportPages();
			})
			.catch(() => {});

	} catch (e) {
		this.$store.commit("showNotification", { content: e });
	}
},
	parseDate(date) {
		if (!date) return "";
		let day = date.substr(8, 10);
		let monthNumber = parseInt(date.substring(5, 7)) - 1;
		let year = date.substring(0, 4);
		return day + " " + this.month_names[monthNumber] + " " + year;
	},
    init() {
      const script = document.createElement("script");
      script.src = "https://unpkg.com/flipbook-vue/dist/vue2/flipbook.min.js";
      script.onload = () => {
        this.$options.components.Flipbook = window.Flipbook;
      };
      document.body.appendChild(script);
    },
	loadPassportPages() {
		axios
		.get("/system/passport/stamp", {
			responseType: 'arraybuffer'
		})
		.then(response => {
			const buffer = response.data;
			const files = unzipSync(new Uint8Array(buffer));

			this.passportPages = Object.values(files).map(file => {
				const blob = new Blob([file], { type: 'image/png' });
				return URL.createObjectURL(blob);
			});
			this.flipbookLoaded = true;
		})
		.catch(() => {});
	},
	handleOnComplete(value) {
		this.booking.bookingCode = value;
	},
    handleOnChange(value) {
		if (value) {
			this.booking.bookingCode = value;
			if (value.length < 5) {
				document.getElementById("errorPNR").textContent = "Enter your Air New Zealand PNR";
			} else {
				document.getElementById("errorPNR").textContent = "";
			}
		} else if (value == undefined) {
			document.getElementById("errorPNR").textContent = "Only digit and alphabetical characters allowed";
		}
	},
	handleOnCompleteUA(value) {
		this.booking.ticketNumber = value;
	},
    handleOnChangeUA(value) {
		if (value) {
			this.booking.ticketNumber = value;
			if (value.length < 10) {
				document.getElementById("errorUA").textContent = "Enter your United Airlines PNR";
			} else {
				document.getElementById("errorUA").textContent = "";
			}
		} else if (value == undefined) {
			document.getElementById("errorUA").textContent = "Only digit and alphabetical characters allowed";
		}
	},

  }
};
</script>